import _ from 'underscore'
import GlassFrogModel from 'legacy/GlassFrog/GlassFrogModel'
import MeetingMixin from './mixins/MeetingMixin'

const TacticalMeeting = GlassFrogModel.extend(_.extend({}, MeetingMixin), {
  resourceName: 'tactical_meetings',
})

export default TacticalMeeting
